import { apiSlice } from "@/features/api/ApiSlice";
import {
  Comment,
  Task,
  TaskCreationSchema,
  TasksTable,
  LogEntryOfTask,
} from "../app/types/tasks";
interface TaskUpdateSchema extends TaskCreationSchema {
  id: string;
}


export const tasks = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTaskById: builder.query<Task, number>({
      query: (task_id) => ({
        url: `/tasks/get/${task_id}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: (result, error, arg) => [{ type: "Tasks", id: arg }],
    }),

    getAllTasks: builder.query<TasksTable, { query: string }>({
      query: ({ query }) => ({
        url: `/tasks${query ? "?" + query : ""}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: ["Tasks"],
    }),

    createTask: builder.mutation<Task, TaskCreationSchema>({
      query: (taskData) => ({
        url: "/tasks/create_task",
        method: "POST",
        body: taskData,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Tasks"],
    }),
    updateTask: builder.mutation<
      Task,
      { id: string } & Partial<Omit<TaskUpdateSchema, "id">>
    >({
      query: ({ id, ...taskData }) => ({
        url: `/tasks/update_task/${id}`,
        method: "PUT",
        body: taskData, // Only send provided fields
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Tasks"],
    }),
    deleteTasks: builder.mutation<Task, number>({
      query: (taskData) => ({
        url: `/tasks/delete_task/${taskData}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Tasks"],
    }),
    createTaskComment: builder.mutation<
      Comment[],
      { taskId: number; comment: string }
    >({
      query: (taskData) => ({
        url: `/tasks/create_comment/${taskData.taskId}?comment=${taskData.comment}`,
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Tasks"],
    }),
    updateTaskComment: builder.mutation<
      Comment,
      { commentId: number; comment: string; staffId: string }
    >({
      query: (taskData) => ({
        url: `/tasks/update_comment/${taskData.commentId}`,
        method: "PUT",
        body: {
          comment: taskData.comment,
          staff_id: taskData.staffId,
        },
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Tasks"],
    }),
    deleteTaskComment: builder.mutation<Comment, { commentId: number }>({
      query: (taskData) => ({
        url: `/tasks/delete_comment/${taskData.commentId}`,
        method: "Delete",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["Tasks"],
    }),
    getAuditlogOfTask: builder.query<LogEntryOfTask[], { taskId: string }>({
      query: ({ taskId }) => ({
        url: `/tasks/get_logs/${taskId}`,
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }),
      providesTags: ["Tasks"],
    }),
  }),
});

export const {
useGetTaskByIdQuery,
useGetAllTasksQuery,
useCreateTaskMutation,
useUpdateTaskMutation,
useDeleteTasksMutation,
useCreateTaskCommentMutation,
useUpdateTaskCommentMutation,
useDeleteTaskCommentMutation,
useGetAuditlogOfTaskQuery
} = tasks;
